// extracted by mini-css-extract-plugin
export default {"container":"styles_container__7GobV","title":"styles_title__Di-IC","wrapper":"styles_wrapper__2CFO6","footer":"styles_footer__Bao9P"};